import { render, staticRenderFns } from "./Prez.vue?vue&type=template&id=ad184260"
import script from "./Prez.vue?vue&type=script&lang=js"
export * from "./Prez.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports